import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { MdsRadioButton, MdsRadioGroupComponent } from '@medpacesoftwaredevelopment/designsystem';

@Component({
    selector: 'medpace-needs-travel-radio-group',
    imports: [AlertComponent, MdsRadioGroupComponent],
    templateUrl: './needs-travel-radio-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NeedsTravelRadioGroupComponent {
    public readonly isDisabled: InputSignal<boolean> = input.required();
    public readonly isUpdate: InputSignal<boolean> = input.required();
    public readonly formCtrl: InputSignal<FormControl<boolean | null>> = input.required();
    public readonly label: InputSignal<string> = input.required();

    public readonly radioButtons: MdsRadioButton[] = [
        {
            id: 'needsTravel_Yes_Radio',
            name: 'needsTravel_Yes_Radio',
            label: 'Yes',
            value: true,
        },
        {
            id: 'needsTravel_No_Radio',
            name: 'needsTravel_No_Radio',
            label: 'No',
            value: false,
        },
    ];
}
